import React, { useRef } from 'react'
import { BarChart, CartesianGrid, ResponsiveContainer } from 'recharts'
import { ChartTooltip, XAxis, YAxis, Bar } from '../../components'
import { useBarChartHoverIndex, useMediaQuery, useBarSize } from '../../hooks'
import { formatGraphData, getAxisDomain } from '../../helpers'
import { GraphComponentProps } from '../../types'

const ViewPerAdvertiserChart: React.FC<GraphComponentProps> = ({ data, graphHeight }) => {
  const chartRef = useRef<any>(null)
  const [hoveredIndex, handleBarMouseMove, handleBarMouseLeave] = useBarChartHoverIndex()
  const displayType = useMediaQuery()
  const [barSize, onResize] = useBarSize(-50, data?.length)

  const getMonthFormat = () => {
    switch (displayType) {
      case 'tablet':
        return 'three'
      default:
        return 'one'
    }
  }

  const formattedData = formatGraphData('views', 15, data)
  const domain = getAxisDomain(formattedData, 'views')

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight} debounce={10} onResize={onResize}>
      <BarChart
        ref={chartRef}
        data={formattedData}
        barCategoryGap={3}
        maxBarSize={barSize}
        margin={{ top: 0, left: 0, right: 0, bottom: 0 }}
        onMouseMove={handleBarMouseMove}
        onMouseLeave={handleBarMouseLeave}
      >
        <defs>
          <linearGradient id="color-vpa" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#C3D0FD" />
            <stop offset="1" stopColor="#CDD8FE" />
          </linearGradient>
          <linearGradient id="colorHovered-vpa" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#6081FB" />
            <stop offset="1" stopColor="#7E99FC" />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: getMonthFormat(), chartType: 'bar', barSize })}
        {YAxis({ dataKey: 'views', domain })}
        <CartesianGrid stroke="#CED8FD" vertical={false} strokeDasharray="5 5" />
        {ChartTooltip({ cursor: false })}
        {Bar({
          dataKey: 'views',
          stroke: '#3A64F8',
          hoveredIndex,
          borderRadius: 9,
          graphData: formattedData,
          color: 'url(#color-vpa)',
          colorHovered: 'url(#colorHovered-vpa'
        })}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ViewPerAdvertiserChart
